module.exports = __webpack_public_path__ + "img/ca.42c61d70.svg";